/** Shared motion curves. Pattern durations and travel distances remain independent. */
export const MOTION_EASING = {
  settle: 'cubic-bezier(0.1, 0.9, 0.2, 1)',
  accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
  stateChange: 'cubic-bezier(0.2, 0, 0, 1)',
} as const;

/** Candidate companion to dialog rise: deliberate reveal, quicker retreat. */
export const STACK_REVEAL_MOTION = {
  expand: { duration: 300, easing: MOTION_EASING.settle },
  collapse: { duration: 180, easing: MOTION_EASING.accelerate },
} as const;
